/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BoxDto } from './BoxDto';
import {
    BoxDtoFromJSON,
    BoxDtoFromJSONTyped,
    BoxDtoToJSON,
    BoxDtoToJSONTyped,
} from './BoxDto';
import type { BoxGoodsDto } from './BoxGoodsDto';
import {
    BoxGoodsDtoFromJSON,
    BoxGoodsDtoFromJSONTyped,
    BoxGoodsDtoToJSON,
    BoxGoodsDtoToJSONTyped,
} from './BoxGoodsDto';

/**
 * 
 * @export
 * @interface Candidate
 */
export interface Candidate {
    /**
     * 
     * @type {BoxDto}
     * @memberof Candidate
     */
    box?: BoxDto;
    /**
     * 
     * @type {Array<BoxGoodsDto>}
     * @memberof Candidate
     */
    lines?: Array<BoxGoodsDto>;
    /**
     * 
     * @type {string}
     * @memberof Candidate
     */
    disabledReason?: string;
}

/**
 * Check if a given object implements the Candidate interface.
 */
export function instanceOfCandidate(value: object): value is Candidate {
    return true;
}

export function CandidateFromJSON(json: any): Candidate {
    return CandidateFromJSONTyped(json, false);
}

export function CandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Candidate {
    if (json == null) {
        return json;
    }
    return {
        
        'box': json['box'] == null ? undefined : BoxDtoFromJSON(json['box']),
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(BoxGoodsDtoFromJSON)),
        'disabledReason': json['disabledReason'] == null ? undefined : json['disabledReason'],
    };
}

export function CandidateToJSON(json: any): Candidate {
    return CandidateToJSONTyped(json, false);
}

export function CandidateToJSONTyped(value?: Candidate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'box': BoxDtoToJSON(value['box']),
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(BoxGoodsDtoToJSON)),
        'disabledReason': value['disabledReason'],
    };
}

